import React, { useState, useEffect, useRef } from 'react';
import Icon from '@mdi/react';

import './Div.css';

const Div = ({ children, ...rest }) => {
    const ref = useRef();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

    useEffect(() => {
        const getDimensions = () => ({
            width: ref.current.offsetWidth,
            height: ref.current.offsetHeight
        })

        const handleResize = () => {
            setDimensions(getDimensions())
        }

        if (ref.current) {
            setDimensions(getDimensions())
        }

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [ref])

    return (
        <div className="Div" ref={ref}>
            { children(dimensions.width, dimensions.height) }
        </div>
    );
}

export default Div;
